const validateUUID = (uuid: string | null) => {

    if (!uuid) return false;

    /* CHECK FOR VALID UUID */
    const uuidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
    return uuidRegex.test(uuid);
};

export default validateUUID;